import styled from 'styled-components'

import { Skeleton } from '@syconium/little-miss-figgy'

export const Body = styled.div``

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
`

export const FilterButton = styled(Skeleton)`
  height: 28px;
  width: 113px;
`

export const ColumnActions = styled(Skeleton)`
  height: 28px;
  width: 228px;
`

export const ColumnAction = styled(Skeleton)`
  display: inline-block;
  height: 28px;
  margin-inline-start: 8px;
  width: 28px;
`

export const ColorDots = styled.div`
  margin-top: 16px;
  overflow: hidden;
  padding: 8px 0;
  white-space: nowrap;
`

export const ColorDot = styled(Skeleton)`
  border-radius: 50%;
  display: inline-block;
  height: 20px;
  margin-inline-end: 16px;
  width: 20px;
`
